
import { computed, defineComponent, PropType } from 'vue'
import { useSpecial } from '@/provider/special'
export default defineComponent({
  name: 'Keywords',
  props: {
    ids: {
      type: Array as PropType<number[]>,
      default: null
    }
  },
  setup(props) {
    const { state, loadKeywords } = useSpecial()
    if (!state.keywords.length) loadKeywords()

    const keywords = computed(() =>
      state.keywords.filter((val, index) =>
        props.ids ? props.ids.includes(val.id) : index < 100
      )
    )
    return {
      keywords
    }
  }
})
